import { type TBadgeColor } from "@components/Badge/Badge";

export const CUSTOMER_STORAGE_SPACE_THRESHOLD = 50;
export const CUSTOMER_STORAGE_BASE_FOLDER_URL = "v1/customer-storage-overview";

export const FOLDER_COLOR_CONFIG: {
  className: string;
  folderName: string;
  badgeColor: TBadgeColor;
}[] = [
  {
    className: "text-orange-dark bg-orange-light",
    folderName: "",
    badgeColor: "orange",
  },
  {
    className: "text-blue-dark bg-paleSky-light",
    folderName: "",
    badgeColor: "blue",
  },
  {
    className: "text-green-dark bg-green-light",
    folderName: "",
    badgeColor: "green",
  },
  {
    className: "text-purple-dark bg-purple-hover",
    folderName: "",
    badgeColor: "purple",
  },
  {
    className: "text-red-dark bg-red-light",
    folderName: "",
    badgeColor: "red",
  },
  {
    className: "text-grey-dark bg-grey-light",
    folderName: "",
    badgeColor: "grey",
  },
];
